function getNumberOfDaysOfYear(year) {
  return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0) ? 366 : 365;
}

export default function yearsToMillis(years) {
  const actualYear = new Date().getFullYear();
  return years * 1000 * 60 * 60 * 24 * getNumberOfDaysOfYear(actualYear);
}
